export default __webpack_public_path__ + "static/media/band@2x-80.de6e5764.jpg";